
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'SvgGradientDefinitions'
})
export default class SvgGradientDefinitions extends Vue {
}
